<template>
  <section class="min-h-screen flex items-center justify-center snap-start bg-amber-50 py-16 px-6">
    <div class="max-w-md mx-auto w-full">
      <h2 class="text-xl font-medium text-gray-800 mb-2 text-center">
        Get updates
      </h2>
      <p class="text-gray-600 text-sm mb-6 text-center">
        We'll let you know when we launch.
      </p>
      <form
        class="flex flex-col gap-3"
        @submit.prevent="submit"
      >
        <IconField>
          <InputIcon class="pi pi-envelope" />
          <InputText
            v-model="email"
            type="email"
            placeholder="Your email"
            class="w-full"
            :disabled="success"
          />
        </IconField>
        <Button
          type="submit"
          label="Sign up"
          :loading="loading"
          :disabled="success || !email.trim()"
          class="w-full"
        />
        <p
          v-if="success"
          class="text-green-700 text-sm text-center"
        >
          Thanks! We'll be in touch.
        </p>
        <p
          v-else-if="errorMessage"
          class="text-red-600 text-sm text-center"
        >
          {{ errorMessage }}
        </p>
      </form>
    </div>
  </section>
</template>

<script setup>
import { ref } from 'vue';
import { signup } from '@/services/newsletterService';

const email = ref('');
const loading = ref(false);
const success = ref(false);
const errorMessage = ref('');

async function submit() {
  const trimmed = email.value?.trim() || '';
  if (!trimmed) return;
  errorMessage.value = '';
  loading.value = true;
  try {
    await signup(trimmed, 'splash');
    success.value = true;
  } catch (err) {
    const data = err.response?.data;
    if (err.response?.status === 422 && data?.errors?.email) {
      errorMessage.value = Array.isArray(data.errors.email) ? data.errors.email[0] : data.errors.email;
    } else {
      errorMessage.value = 'Something went wrong. Please try again.';
    }
  } finally {
    loading.value = false;
  }
}
</script>
